module.exports = __webpack_public_path__ + "img/zoro-wano-removebg-preview.9999d3a7.png";